module.exports = __webpack_public_path__ + "static/img/micro-message.1fd7be4d.svg";